module.exports = __webpack_public_path__ + "img/roc_auc_all.9a5cfb1b.webp";